const getSelectedOffering = (offerings, filteredOfferingTitles = []) => {
  if (!offerings || offerings.length === 0) return void 0;
  const selectedOffering = offerings.find(
    (offering) => offering.title === filteredOfferingTitles[0]
  );
  return selectedOffering ?? offerings[0];
};
export {
  getSelectedOffering
};
//# sourceMappingURL=get-selected-offering.js.map
